<template>
<div>
    <daterangepicker
      @date-changed="update_date_range"
      ref="daterangepicker">
    </daterangepicker>

    <span v-if="loading" class="text-center"><i class="fas fa-spinner fa-pulse"></i></span>

    <fieldset>
      <legend class="legend-custom">Sources</legend>

      <div>
        <button @click="select_all_sources" class="btn btn-link btn-sm btn-custom">
          <i class="fas fa-check-circle"></i> All
        </button>
        <button @click="deselect_all_sources" class="btn btn-link btn-sm btn-custom" style="color: red;">
          <i class="fas fa-times-circle"></i> None
        </button>
        <button v-if="current_user_id" @click="toggle_merged_sources" class="btn btn-link btn-sm btn-custom">
          <i class="fas fa-sync-alt"></i> Toggle merged
        </button>
      </div>

      <div class="source-category-group" v-for="(group, groupIndex) in sourcesByCategory" :key="group.category || 'uncategorized'">
        <div class="category-header">
          <span class="category-name">{{ group.category || 'Uncategorized' }}</span>
          <button @click="select_all_in_category(group.sources)" class="btn btn-link btn-sm btn-custom">all</button>
          <button @click="deselect_all_in_category(group.sources)" class="btn btn-link btn-sm btn-custom category-none-btn">none</button>
        </div>
        <div class="form-check" v-for="(source, index) in group.sources" :key="source.name">
          <input @change="update_data()" class="form-check-input" type="checkbox" v-model="selected_sources" :value="source.name" :id="source.name">
          <label class="form-check-label" :for="source.name">
            <span :style="{color: source.color}">●</span>
            {{ source.name }}
            <button v-if="current_user_id && source.merged" @click="delete_source(source.name)" class="btn btn-link btn-sm btn-custom" style="color: red;">
              <i class="fas fa-trash fa-sm"></i>
            </button>
          </label>
        </div>
      </div>

    <!-- Button to Open the Modal -->
    <button v-if="current_user_id" type="button" class="btn btn-primary-outline btn-sm" data-bs-toggle="modal" data-bs-target="#mergeEventsModal">
      <i class="fas fa-sync-alt"></i> Merge Events
    </button>
    
    </fieldset>

    <!-- <div class="container">
      <div class="row">
        <div class="col-4">
          <button class="btn btn-primary" @click="randomly_move_markers">
            <i class="fas fa-random"></i> Move markers
          </button>
        </div>
        <div class="col-4">
          <input type="number" class="form-control" v-model="randomly_move_markers_max_distance" placeholder="Max distance">
        </div>
        <div class="col-4">
          <button class="btn btn-secondary" @click="reset_marker_positions">
            <i class="fas fa-undo"></i> Reset positions
          </button>
        </div>
      </div>
    </div> -->

    <div class="form-group d-flex align-items-center">
      <div class="flex-grow-1">
        <label for="species">
          Species
          (
            <input type="checkbox" class="form-check-input" id="showAllSpecies" v-model="showAllSpecies" @change="update_data()">
            <label class="form-check-label" for="showAllSpecies">&nbsp; show all</label>
          )
        </label>
        <select class="form-control" id="species" v-model="selected_species" @change="update_data()">
          <option value="">All species</option>
          <option v-for="(species, index) in filteredSpecies" :key="index" :value="species.name">{{ species.display_name || species.name }} ({{ species.value.count }} reports for {{ species.value.places.length }} places)</option>
        </select>
      </div>
      
    </div>

    <div class="form-group">
      <label for="continent">
        Continent
        <i class="fas fa-exclamation-triangle text-warning" title="Filtering by continent is based on large bounding boxes and can be inaccurate."></i>
      </label>
      <select class="form-control" id="continent" v-model="selectedContinent" @change="update_data">
        <option value="">All continents</option>
        <option value="Africa">Africa</option>
        <option value="Antarctica">Antarctica</option>
        <option value="Asia">Asia</option>
        <option value="Australia">Australia</option>
        <option value="Europe">Europe</option>
        <option value="NorthAmerica">North America</option>
        <option value="SouthAmerica">South America</option>
      </select>
    </div>

    <div v-if="current_user_id">
      <label>
        <input type="checkbox" v-model="showIncorrect" @change="update_data()"/> Show Incorrect Events
      </label>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <!-- Checkbox with integrated number of days input -->
        <div class="form-check">
          <input @change="highlight_recent_events()" class="form-check-input" type="checkbox" v-model="highlight_recent" id="highlight_recent">
          <label class="form-check-label" for="highlight_recent">
            Highlight recent events 
            <!-- Wrapping number of days within parentheses -->
            (<input @change="highlight_recent_events()" type="number" class="form-control form-control-sm" id="number_of_days" v-model="number_of_days" style="width:60px;display:inline;text-align: right;" min="1" max="365"> days)
          </label>
        </div>
      </div>
    </div>

    <!-- <strong v-if="events">{{ events.length }}</strong> events 
    <strong v-if="location_count">{{ location_count }}</strong> locations  -->
    <strong v-if="visible_events" class="float-right">{{ visible_events.length }}</strong> visible locations

    <!-- Export button -->
    <button v-if="current_user_id" @click="export_selected_events" class="btn btn-link btn-sm btn-custom" :disabled="loading_export">
      <i class="fas fa-file-export"></i> Export events
    </button>


    <!-- Modal -->
    <div class="modal fade" id="mergeEventsModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Merging Events</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group">
                <label for="max_distance_in_kms">Max Distance in Kms</label>
                <input type="number" class="form-control" id="max_distance_in_kms" v-model="max_distance_in_kms">
              </div>
              <div class="form-group">
                <label for="max_days_apart">Max Days Apart</label>
                <input type="number" class="form-control" id="max_days_apart" v-model="max_days_apart">
              </div>
              <div class="form-group">
                <label for="max_host_levenshtein_distance">Max Host Levenshtein Distance</label>
                <input type="number" class="form-control" id="max_host_levenshtein_distance" v-model="max_host_levenshtein_distance">
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="call_merge_events" :disabled="merging_events">
              <i class="fas fa-sync-alt"></i> Merge
              <span v-if="merging_events" class="text-center"><i class="fas fa-spinner fa-pulse"></i></span>
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
    

    <div id="visualization-event-container">
      <div id="visualization-container">
        <div id="leaflet-map"></div>
        <div id="time-distribution">
          <publication-distribution-chart ref="publication-chart"></publication-distribution-chart>
        </div>
      </div>
      <div id="event-container">
        <event :event="event"></event>
        <p v-if="event" class="text-center">
          <strong>{{ this.nearby_events.length }}</strong> Nearby event(s)
          (
            <input @change="get_nearby_events" type="number" class="form-control form-control-sm" v-model="nearby_events_max_distance" placeholder="Max distance" style="width:60px;display:inline;text-align: right;" min="0"> km
            and
            <input @change="get_nearby_events" type="number" class="form-control form-control-sm" v-model="nearby_events_max_days" placeholder="Max days" style="width:60px;display:inline;text-align: right;" min="0"> days
          )
        </p>
        <event v-for="(event, index) in this.nearby_events" :key="index" :event="event"></event>
      </div>
    </div>

</div>

</template>

<script>
import L from 'leaflet';
import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import 'leaflet.fullscreen/Control.FullScreen.js'
import 'leaflet.fullscreen/Control.FullScreen.css';

import axios from 'axios';
import moment from "moment";
import Split from 'split.js'

import { colors } from '../utils';

import PublicationDistributionComponent from './publication-distribution.vue'
import DaterangepickerComponent from './daterangepicker.vue';
import EventDescriptorComponent from './event-descriptor.vue';
import EventComponent from './event.vue';

export default {
  name: "map-distribution",
  components: {
    'publication-distribution-chart': PublicationDistributionComponent,
    'daterangepicker': DaterangepickerComponent,
    'event-descriptor': EventDescriptorComponent,
    'event': EventComponent,
},
  props: [],
  data() {
    return {
      map: null,
      markers: [],
      loading: false,
      merging_events: false,
      merging_events_progress_data: {},
      events: [],
      visible_events: [],
      location_count: 0,
      stats: {},
      event: null,
      marker: null,
      nearby_events: [],
      highlight_recent: false,
      number_of_days: 30,
      sources: [],
      selected_sources: [],
      selected_species: "",
      selectedContinent: "",
      showIncorrect: false,
      start_date: moment().subtract(3, 'months').format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD'),
      nearby_events_max_distance: 100,
      nearby_events_max_days: 15,
      randomly_move_markers_max_distance: 0.1,
      
      max_distance_in_kms: 200,
      max_days_apart: 10,
      max_host_levenshtein_distance: 5,

      timeout: null,
      dev: false,
      current_user_id: null,

      continentBoundingBoxes: {
        Africa: { minLat: -34.83333, maxLat: 37.33333, minLng: -17.625, maxLng: 51.20833 },
        Asia: { minLat: 1.0, maxLat: 77.83333, minLng: 26.03333, maxLng: 180.0 },
        Europe: { minLat: 35.0, maxLat: 71.0, minLng: -25.0, maxLng: 40.0 },
        NorthAmerica: { minLat: 5.5, maxLat: 83.0, minLng: -168.5, maxLng: -52.5 },
        SouthAmerica: { minLat: -56.0, maxLat: 12.5, minLng: -81.5, maxLng: -34.5 },
        Australia: { minLat: -55.0, maxLat: -10.0, minLng: 110.0, maxLng: 180.0 },
        Antarctica: { minLat: -90.0, maxLat: -60.0, minLng: -180.0, maxLng: 180.0 }
      },
      showAllSpecies: false
    }
  },
  computed: {
    sourcesByCategory() {
      const groups = new Map();
      for (const source of this.sources) {
        const cat = (source.category && source.category.trim()) ? source.category : null;
        if (!groups.has(cat)) groups.set(cat, []);
        groups.get(cat).push(source);
      }
      const entries = Array.from(groups.entries());
      entries.sort((a, b) => {
        if (a[0] === null) return 1;
        if (b[0] === null) return -1;
        return (a[0] < b[0]) ? -1 : 1;
      });
      return entries.map(([category, sources]) => ({ category, sources }));
    },
    filteredSpecies() {
      // $search_species is a list of pairs (species name in db, name to display)
      var species_names = window.$search_species.map(species => species[0]);
      var species_display_names = window.$search_species.map(species => species[1]);
      if (!this.showAllSpecies) {
        if (this.stats && this.stats.species) {
          const filteredSpecies = this.stats.species.filter(species => species_names.includes(species.name));
          // add the display name to the species
          for (var i = 0; i < filteredSpecies.length; i++) {
            filteredSpecies[i].display_name = species_display_names[species_names.indexOf(filteredSpecies[i].name)];
          }
          // when showAllSpecies is true, sort the species as it is in $search_species
          filteredSpecies.sort((a, b) => {
            return species_names.indexOf(a.name) - species_names.indexOf(b.name);
          });
          return filteredSpecies;
        }
      }
      return this.stats.species;
    }
  },
  mounted() {
    if (window.dev) {
      this.dev = true;
    }
    
    this.current_user_id = window.$user_id;

    this.load_events();
    
    // split the visualization-container and event-container in two resizable parts
    Split(['#visualization-container', '#event-container'], {
        sizes: [60, 40],
        minSize: 100,
        gutterSize: 5,
    });
  },
  methods: {
    load_events() {
      this.loading = true;

      axios.get('/events/', {
        params: {
          start_date: this.start_date,
          end_date: this.end_date
        }
      })
        .then(response => {
          this.events = response.data;
        
          // get various elements from events:
          // - distinct sources from events
          // - min and max event_dates
          var source_names = [];
          var source_to_category = {};
          var min_event_date = null;
          var max_event_date = null;
          for (var i = 0; i < this.events.length; i++) {
            const event = this.events[i];
            
            // get the source name and category if not already stored
            if (source_names.indexOf(event.source) == -1) {
              source_names.push(event.source);
              source_to_category[event.source] = (event.category && event.category.trim()) ? event.category : null;
            }

            // get the min and max event_dates
            const event_date = event.data.event_date[0].value;
            if (min_event_date == null || event_date < min_event_date) {
              min_event_date = event_date;
            }
            if (max_event_date == null || event_date > max_event_date) {
              max_event_date = event_date;
            }
          }

          // store the min and max event_dates
          this.min_event_date = min_event_date;
          this.max_event_date = max_event_date;

          // convert sources to objects of type {name: "source_name", category: "...", color: "red"}
          this.sources = source_names.map(source_name => ({ name: source_name, category: source_to_category[source_name] || null }));
          // order sources by name, except for "Merged ..." that go to the end
          this.sources.sort((a, b) => (a.name > b.name) ? 1 : -1);
          this.sources.sort((a, b) => (a.name.startsWith("Merged")) ? 1 : -1);
          
          // add a field merged: true if the source name starts with "Merged"
          for (var i = 0; i < this.sources.length; i++) {
            const source = this.sources[i];
            source.merged = source.name.startsWith("Merged ");
          }

          // associate a color to each source
          for (var i = 0; i < this.sources.length; i++) {
            const source = this.sources[i];
            
            // if variable $data_sources contains an element with the same name that has a defined color, use it
            const data_source = window.$data_sources.find(data_source => data_source.name == source.name);
            if (data_source && data_source.html_color) {
              source.color = data_source.html_color;
              continue;
            }
            // if no color is defined, use the default colors
            else {
              source.color = colors[i % colors.length + 3];
              // add this color to $data_sources
              window.$data_sources.push({ name: source.name, html_color: source.color });
            }
          }
          
          // by default, all sources are selected, except for "Merged ..." that are deselected
          this.selected_sources = this.sources.filter(source => !source.name.startsWith("Merged ")).map(source => source.name);
          
          // load the map
          this.load_map(this.events);
          
          // load the stats
          this.get_stats_and_data();
        })
        .finally(() => {
          this.loading = false;
          this.update_data();
        });
    },
    load_map(events) {

      var addressPoints = [];
      for (var i = 0; i < events.length; i++) {
        const event = events[i];

        for (var j = 0; j < event.data.places.length; j++) {
          const location = event.data.places[j].value;
          if (location.lat && location.lon)
            addressPoints.push([location.lat, location.lon, event]);
        }

      }
      this.location_count = addressPoints.length;
      console.log("addressPoints", addressPoints);

      // Canonical OSM URL + referrerPolicy per https://operations.osmfoundation.org/policies/tiles/
      var tiles = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        referrerPolicy: 'strict-origin-when-cross-origin',
      }),

        latlng = L.latLng(0, 0);
      if (this.map != null) {
        this.map.off();
        this.map.remove();
      }
      this.map = L.map('leaflet-map', {
        center: latlng,
        zoom: 1,
        zoomAnimation: false,
        layers: [tiles],
        fullscreenControl: true,
      });

      var zoomForDisablingClusters = 15
      if (!this.clustering) {
        zoomForDisablingClusters = 0
      }
      var markers = L.markerClusterGroup({
        disableClusteringAtZoom: zoomForDisablingClusters,
        iconCreateFunction: function (cluster) {
          return L.divIcon({
            html: "",
            className: 'custom-cluster',
            iconSize: null
          });
        }
      });

      this.markers = [];
      for (var i = 0; i < addressPoints.length; i++) {
        var a = addressPoints[i];
        var event = a[2];

        const title = a[2].subject;

        var content = "<h3 class='text-primary text-center'>";
        content += title;
        content += "</h3>";

        // var marker = L.marker(new L.LatLng(lat, lon), { title: title, icon: markerIcon });
        var base_html_color = this.sources.find(source => source.name == event.source).color;
        const opacity = this.get_opacity_for_event(event, this.number_of_days);
        let marker = L.circleMarker(a, {radius:6, stroke:0, color: base_html_color, fillColor: base_html_color, fillOpacity: opacity});
        marker.data = { event: event };

        this.markers.push(marker);

        //marker.bindPopup(title);
        marker.bindPopup(content, { maxHeight: 200, maxWidth: 400 });
        markers.addLayer(marker);
        
        // on marker mouseover, select the event
        marker.on('mouseover', (e) => {
          console.log("marker click", e);
          this.event = marker.data.event;
          this.marker = marker;
          this.get_nearby_events();
          
          this.update_data();
        });
      }

      this.map.addLayer(markers);

      // on zoomend or mooveend, update the chart after waiting some time
      // stop the execution of the previous setTimeout if any (to avoid multiple calls)
      this.map.on('zoomend', () => {
        if (this.timeout)
          clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.update_data();
        }, 0);
      });
      this.map.on('moveend', () => {
        if (this.timeout)
          clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.update_data();
        }, 0);
      });
    },

    export_selected_events() {
      const event_ids = this.visible_events.map(event => event.id);
      
      var url = '/events/export/' + event_ids.join(',') + '/';
      window.open(url);
      
    },
    
    isEventInContinent(event, continent) {
      const places = event.data.places;
      for (var i = 0; i < places.length; i++) {
        const place = places[i];
        const lat = place.value.lat;
        const lon = place.value.lon;
        if (lat >= this.continentBoundingBoxes[continent].minLat && lat <= this.continentBoundingBoxes[continent].maxLat &&
            lon >= this.continentBoundingBoxes[continent].minLng && lon <= this.continentBoundingBoxes[continent].maxLng) {
          return true;
        }
      }
      return false;
    },
    
    highlight_selected_marker() {
      // highlight selected marker
      this.map.eachLayer(function (layer) {
        if (layer instanceof L.CircleMarker) {
          const event = layer.data.event;
          if (this.event.id == event.id) {
            layer.bringToFront();
            layer.setStyle({fillOpacity: 0.8, stroke: 1, radius: 8, color: "#33FF36"});
          }
        }
      }.bind(this));
    },
    highlight_recent_events() {
      console.log("highlight_recent_events", this.highlight_recent);
      // recreate the icon for each marker
      this.map.eachLayer(function (layer) {
        if (layer instanceof L.CircleMarker) {
          const event = layer.data.event;

          // add class highlight-icon to marker if the event is recent
          const event_date = event.data.event_date[0].value;
          if (this.highlight_recent && event_date >= moment().subtract(this.number_of_days, 'days').format('YYYY-MM-DD')) {
            layer.bringToFront();
            layer.setStyle({fillOpacity: 0.8, stroke: 1, radius: 8, color: "yellow"});
          } else {
            layer.bringToBack();
            const opacity = this.get_opacity_for_event(event, this.number_of_days);
            layer.setStyle({fillOpacity: opacity, stroke: 0, radius: 6});
          }
        }
      }.bind(this));
    },
    filter_events() {
      // remove all markers
      console.log("remove all markers");
      for (var i = 0; i < this.markers.length; i++) {
        const marker = this.markers[i];
        this.map.removeLayer(marker);
      }

      // only add markers that should be visible
      for (var i = 0; i < this.markers.length; i++) {
        const marker = this.markers[i]; 
        const event = marker.data.event;

        var visible = true;
        
        // if the event is incorrect and the user does not want to see incorrect events,
        //  hide the marker
        if (!this.showIncorrect && this.isIncorrect(event))
          visible = false;

        // if the event_date is not in the range, hide the marker
        const event_date = event.data.event_date[0].value;
        if (event_date < this.start_date || event_date > this.end_date)
          visible = false;
        
        // if the continent is selected and the event is not in the continent, hide the marker
        if (visible && this.selectedContinent && !this.isEventInContinent(event, this.selectedContinent))
          visible = false;

        // if the event source is not selected, hide the marker
        if (visible && this.selected_sources.indexOf(event.source) == -1)
          visible = false;
          
        // if a species is selected and the event does not contain it, hide the marker
        if (visible && this.selected_species != "" && event.data.species.map( s => s.value ).indexOf(this.selected_species) == -1)
          visible = false;
        
        if (visible)
          this.map.addLayer(marker);
      }
    },
    set_event(event_json) {
      console.log("set_event", event_json);
      this.event = event_json;
      // this.event = JSON.parse(event_json);
    },
    update_data() {
      console.log("update_data", this.selected_sources);
      this.filter_events();

      if (this.highlight_recent_events)
        this.highlight_recent_events();   
      
      if (this.event)
        this.highlight_selected_marker();

      this.load_publication_chart_data();
    },
    get_opacity_for_event(event, number_of_days) {
      return 1;
      // var event_date = new Date(event.data.event_date[0].value);
      // var current_date = new Date();

      // if ((current_date - event_date) > (365 * 24 * 60 * 60 * 1000)) {
      //   return 0.1;
      // } else if ((current_date - event_date) < (number_of_days * 24 * 60 * 60 * 1000)) {
      //   return 0.5;
      // }

      // var time_diff = current_date - event_date;
      // var normalized_diff = time_diff / (number_of_days * 24 * 60 * 60 * 1000);
      // var opacity = 0.1 + (normalized_diff * 0.4);
      // return opacity;
    },
    load_publication_chart_data() { 
      // use $refs to call the create_chart data on publication-chart
      this.$refs["publication-chart"].create_chart(this.get_visible_events());
    },
    update_date_range(data) {
      console.log("update_date_range", data);
      this.start_date = data.start_date;
      this.end_date = data.end_date;

      this.load_events();
      
      // this.update_data();
    },
    get_visible_events() {
      var events = [];
      var self = this;
      this.map.eachLayer(function (layer) {
        if (layer instanceof L.CircleMarker) {
          if (self.map.getBounds().contains(layer.getLatLng())) {
            const event = layer.data.event;
            events.push(event);
          }
        }
      });

      this.visible_events = events;
      this.get_stats_and_data();

      return events;
    },
    get_stats_and_data() {
      const species = {};
      const event_dates = {};
      for (var i = 0; i < this.visible_events.length; i++) {
        const event = this.visible_events[i];
        const places = event.data.places || [];

        // store information about the species
        var event_species = event.data.species;
        for (var j = 0; j < event_species.length; j++) {
          const species_name = event_species[j].value;
          if (species[species_name] == undefined) {
            species[species_name] = { count: 1, events: [event], places: places };
          } else {
            species[species_name].count += 1;
            species[species_name].events.push(event);
            species[species_name].places = species[species_name].places.concat(places);
          }
        }
        
        // store information about the event dates
        const event_date = event.data.event_date[0].value;
        if (event_dates[event_date] == undefined) {
          event_dates[event_date] = { count: 1, events: [event], places: places };
        } else {
          event_dates[event_date].count += 1;
          event_dates[event_date].events.push(event);
          event_dates[event_date].places = event_dates[event_date].places.concat(places);
        }
      }
      
      // species elements should be sorted by descending count
      var species_array = [];
      for (var key in species) {
        species_array.push({ name: key, value: species[key] });
      }
      species_array.sort((a, b) => (a.value.count < b.value.count) ? 1 : -1);
      
      this.stats = {
        species: species_array,
        event_dates: event_dates,
      };
    },
    get_nearby_events() {
      var nearby_events = [];
      var max_distance_in_meters = this.nearby_events_max_distance * 1000;
      var max_days_in_milliseconds = this.nearby_events_max_days * 24 * 60 * 60 * 1000;
      var current_event_date = new Date(this.event.data.event_date[0].value).getTime();
    
      var self = this;
      this.map.eachLayer(function (layer) {
        if (layer instanceof L.CircleMarker) {
          const event = layer.data.event;
    
          // don't add the current event
          if (event == self.event)
            return;
    
          var distance = self.marker.getLatLng().distanceTo(layer.getLatLng());
          var event_date = new Date(event.data.event_date[0].value).getTime();
          var date_difference = Math.abs(current_event_date - event_date);
    
          if (distance <= max_distance_in_meters && date_difference <= max_days_in_milliseconds) {
            nearby_events.push(event);
          }
        }
      });
    
      // sort the events by ascending event_date
      nearby_events.sort((a, b) => (a.data.event_date[0].value < b.data.event_date[0].value) ? -1 : 1);
    
      this.nearby_events = nearby_events;
      return nearby_events;
    },

    randomly_move_marker(marker) {
      // Generate random latitude and longitude offsets
      const lat_offset = (Math.random() - 0.5) * 2 * this.randomly_move_markers_max_distance;
      const lng_offset = (Math.random() - 0.5) * 2 * this.randomly_move_markers_max_distance;

      // Get current position
      const current_position = marker.getLatLng();
      console.log("current_position", current_position);

      // Store original position if it doesn't exist
      if (!marker.original_position) {
        marker.original_position = current_position;
      }

      // Calculate new position
      const new_position = L.latLng(
        current_position.lat + lat_offset,
        current_position.lng + lng_offset
      );

      // Set new position
      marker.setLatLng(new_position);
    },

    randomly_move_markers() {
      for (var i = 0; i < this.markers.length; i++) {
        this.randomly_move_marker(this.markers[i]);
      }
    },

    reset_marker_positions() {
      for (var i = 0; i < this.markers.length; i++) {
        const marker = this.markers[i];
        if (marker.original_position) {
          marker.setLatLng(marker.original_position);
        }
      }
    },
    
    delete_source(source_name) {
      axios.delete(`/events/delete-source/${source_name}/`)
        .then(response => {
          // remove this source from sources
          this.sources = this.sources.filter(source => source.name != source_name);
          console.log(response);
        })
        .catch(error => {
          console.log(error);
        });
    },
    
    select_all_sources() {
      this.selected_sources = this.sources.map(source => source.name);
      this.update_data();
    },
    deselect_all_sources() {
      this.selected_sources = [];
      this.update_data();
    },
    select_all_in_category(sources) {
      const names = sources.map(s => s.name);
      names.forEach(name => {
        if (this.selected_sources.indexOf(name) === -1) this.selected_sources.push(name);
      });
      this.update_data();
    },
    deselect_all_in_category(sources) {
      const names = sources.map(s => s.name);
      this.selected_sources = this.selected_sources.filter(name => names.indexOf(name) === -1);
      this.update_data();
    },

    isIncorrect(event) {
        if (event.data._correct && event.data._correct[0].user_labels) {
          return event.data._correct[0].user_labels.some(label => label.correct === false);
        }
        return false;
    },

    toggle_merged_sources() {
      let first_merged_source = this.sources.find(source => source.name.startsWith('Merged '));
      let target_state = first_merged_source ? !this.selected_sources.includes(first_merged_source.name) : true;
      this.sources.forEach(source => {
        if (source.name.startsWith('Merged ')) {
          let index = this.selected_sources.indexOf(source.name);
          if (target_state && index === -1) {
            this.selected_sources.push(source.name);
          } else if (!target_state && index !== -1) {
            this.selected_sources.splice(index, 1);
          }
        }
      });
      this.update_data();
    },
    
    call_merge_events() {
      this.merging_events = true;

      axios.post(`/events/event-fusion/${this.max_distance_in_kms}/${this.max_days_apart}/${this.max_host_levenshtein_distance}/`, {})
        .then(response => {
          // reload the events
          this.load_events();
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.merging_events = false;
        });
    }
  }
}
</script>

<style>
#leaflet-map {
  height: 400px;
  /* width: 100%; */
  border: 1px solid #AAA;
  /* Show resize control */
  resize: vertical;
  overflow: auto;
}
/* Hide scrollbars */
#leaflet-map::-webkit-scrollbar {
  opacity: 0.1;
}

#visualization-event-container {
    display: flex;
    flex-direction: row;
}

.gutter {
    background-color: #eee;
    background-repeat: no-repeat;
    background-position: 50%;
}

.gutter.gutter-horizontal {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==');
    cursor: col-resize;
}

.text-strike {
    text-decoration: line-through;
}
    
fieldset {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px;
  margin: 20px 0;
}

.legend-custom {
  font-size: 1.3em;
  width: auto;
  padding: 0 10px;
  border-bottom: none;
}

.btn-custom {
  color: #007bff;
}

.btn-custom:hover {
  color: #0056b3;
}

.source-category-group {
  margin-bottom: 0.5rem;
}

.source-category-group .category-header {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-bottom: 0.2rem;
  font-size: 0.9rem;
}

.source-category-group .category-name {
  font-weight: 600;
  margin-right: 0.25rem;
}

.source-category-group .category-header .btn-sm {
  padding: 0 0.25rem;
  font-size: 0.75rem;
}

.source-category-group .category-none-btn {
  color: red;
}

.source-category-group .category-none-btn:hover {
  color: #c82333;
}
</style>